module.exports = __webpack_public_path__ + "static/media/7f5a805f-22af-4c2d-b5f9-ab2f4738f783.08711397.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274163/7f5a805f-22af-4c2d-b5f9-ab2f4738f783.ttf
// module id = 1673
// module chunks = 2